import React from "react";
import TrueIcon from "../components/Icons/True";
import FalseIcon from "../components/Icons/False";
import { StyledPricing } from "../components/Styles";
import Consultation from "../components/Consultation";
import { useTranslation } from "react-i18next";

const WordpressPricing = () => {
  const { t, i18n } = useTranslation();

  return (
    <StyledPricing.Container>
      <StyledPricing.Description>
        <p>
          <StyledPricing.Title lang={i18n.language}>
            {t("wordpressPricing.title")}
          </StyledPricing.Title>

          {t("wordpressPricing.description1")}
          <br />
          {t("wordpressPricing.description2")}
          <br />
          {t("wordpressPricing.description3")}
        </p>
      </StyledPricing.Description>

      <StyledPricing.PricingTable>
        <StyledPricing.Table>
          <thead>
            <StyledPricing.HeaderRow>
              <StyledPricing.HeaderCell />
              <StyledPricing.HeaderCell>
                {t("wordpressPricing.table.basic")}
              </StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("wordpressPricing.table.standard")}
              </StyledPricing.HeaderCell>
            </StyledPricing.HeaderRow>
          </thead>

          <tbody>
            {/* Text comparison rows */}
            {[
              ["pages", "five", "ten"],
              ["hosting", "sharedHosting", "vpsHosting"],
              ["maintenance", "sixMonth", "oneYear"],
              ["backups", "weekly", "daily"],
              ["theme", "customTheme", "customTheme"],
              ["revisions", "two", "three"],
            ].map(([label, basic, standard]) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`wordpressPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`wordpressPricing.table.${basic}`)}
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`wordpressPricing.table.${standard}`)}
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Included in both */}
            {[
              "responsive",
              "gallery",
              "video",
              "social",
              "training",
              "contactForms",
              "ssl",
              "blog",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`wordpressPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Standard only */}
            {[
              "ecommerce",
              "multilanguage",
              "seo",
              "docker",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`wordpressPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><FalseIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Price row */}
            <StyledPricing.Row>
              <StyledPricing.Cell />
              <StyledPricing.Cell>{t("wordpressPricing.table.price-basic")}</StyledPricing.Cell>
              <StyledPricing.Cell>{t("wordpressPricing.table.price-standard")}</StyledPricing.Cell>
            </StyledPricing.Row>
          </tbody>
        </StyledPricing.Table>
      </StyledPricing.PricingTable>
      <div>
        <Consultation text={
          <>
            {t("customPackage")}
            <br />
            {t("contactus")}
          </>
        } />
      </div>
    </StyledPricing.Container>
  );
};

export default WordpressPricing;